import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'kodit-jbkjs-input-mask',
  templateUrl: './jbkjs-input-mask.component.html',
  styleUrls: ['./jbkjs-input-mask.component.scss'],
})
export class JbkjsInputMaskComponent implements OnInit {
  @Input()
  disabled = false;
  @Input()
  showLongLabel = false;
  @Input()
  showShortLabel = false;
  @Input()
  control: FormControl | AbstractControl;

  constructor() {}

  ngOnInit(): void {}
}
